
import CarrouselProducts from './carrousel-products.vue'
import Button from '@/components/buttons/Button'
import Picture from '@/components/picture/lole-picture'
export default {
  components: { Picture, Button, CarrouselProducts },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      richContent: null,
      story: null,
    }
  },
  computed: {
    productRichContent() {
      const productMeta = this.product.metafield
      const prcStory = this.wording
      const rcData = []
      if (!productMeta) return
      const pimTrigger = productMeta.pdp_rich_content
        ? productMeta.pdp_rich_content
        : null

      if (!pimTrigger) return

      // Only get the actual content stories
      for (const story in prcStory) {
        if (prcStory.hasOwnProperty(story)) {
          if (
            story !== '_uid' &&
            story !== '_editable' &&
            story !== 'component' &&
            !story.includes('archive')
          ) {
            if (prcStory[story].length > 0) rcData.push(prcStory[story][0])
          }
        }
      }

      // filter content based on triggers from pim
      return rcData.filter((story) => {
        return pimTrigger.includes(story.pim_trigger)
      })
    },
  },
  methods: {
    resolveCtaUrl(url) {
      this.$router.push(this.localePath(`/${url}`))
    },
  },
}
